export default "__VITE_ASSET__CHhtDyKe__"